import { useEffect, useState } from 'react';
import api from '../services/api';

// ---------------------------------------------------------------------------
// Is this the read-only FOOM archive? (server FOOM_READ_ONLY=1, see
// server/utils/readOnly.js and components/ArchiveBanner.js.)
//
// One request per page load, shared by every caller: the promise is cached at
// module level. On the live site the answer is { read_only: false }. Against an
// older server with no /api/archive route the SPA catch-all returns HTML, so
// read_only is undefined — treated as "not the archive", never as an error.
// ---------------------------------------------------------------------------
let cached = null;

export function loadArchive() {
  if (!cached) {
    cached = api.get('/api/archive')
      .then((res) => (res.data && res.data.read_only === true ? res.data : null))
      .catch(() => { cached = null; return null; });
  }
  return cached;
}

/** null until known, and on the live site; the archive info object in the archive. */
export function useArchive() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    loadArchive().then((a) => { if (alive) setInfo(a); });
    return () => { alive = false; };
  }, []);
  return info;
}
